export default "__VITE_ASSET__Cq$dvp7v__"